import React from "react";
//MUI Components
import Typography from "@mui/material/Typography";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
//Functions dayjs
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import isoWeek from "dayjs/plugin/isoWeek";
import weekOfYear from "dayjs/plugin/weekOfYear";
import dayjs from "dayjs";
import "dayjs/locale/fr";
//Functions Hook Form
import { Controller, useFormContext } from "react-hook-form";

dayjs.extend(isoWeek);
dayjs.extend(weekOfYear);
dayjs.locale("fr");

export default function SelectDateVente() {
	const { getValues, watch, control, setValue } = useFormContext();

	const dates = [
		{
			label: "Date de début",
			helperText: "Sélectionner la date de début pour passer commande.",
			value: "debutVente",
		},
		{
			label: "Date de fin",
			helperText: "Sélectionner la date de fin pour passer commande.",
			value: "finVente",
		},
		{
			label: "Date de livraison",
			helperText:
				"Sélectionner la date où les commandes pourront être récupérées",
			value: "livraisonVente",
		},
	];

	React.useEffect(() => {
		watch("livraisonVente") &&
			setValue(
				"venteID",
				"Vente-Semaine-" +
					getValues("livraisonVente").week() +
					"-" +
					getValues("livraisonVente").format("YYYY")
			);
	});

	return (
		<LocalizationProvider
			dateAdapter={AdapterDayjs}
			adapterLocale="fr"
		>
			<Grid
				columnSpacing={2}
				rowGap={2}
				container
				justifyContent="flex-start"
			>
				<Grid
					variant="outlined"
					size={{ xs: 12, sm: 6 }}
				>
					<Stack spacing={2}>
						{dates.map((item) => (
							<Controller
								key={item.label}
								name={item.value}
								control={control}
								defaultValue={null}
								render={({ field }) => (
									<DatePicker
										label={item.label}
										value={field.value}
										onChange={(newValue) =>
											field.onChange(newValue)
										}
										slotProps={{
											textField: {
												helperText: item.helperText,
											},
										}}
									/>
								)}
							/>
						))}
					</Stack>
				</Grid>
				{watch("debutVente") &&
					watch("finVente") &&
					watch("livraisonVente") && (
						<Grid
							component={Alert}
							size={{ xs: 12, sm: 6 }}
							severity="info"
							sx={{ "& .MuiAlert-icon": { fontSize: 40 } }}
						>
							<AlertTitle
								variant="h5"
								pt={0.5}
							>
								La vente aura lieu :
							</AlertTitle>
							<Typography
								variant="body1"
								lineHeight={1.8}
							>
								La semaine {getValues("debutVente").week()} du{" "}
								<b>
									{getValues("debutVente").format(
										"dddd D MMMM"
									)}
								</b>{" "}
								au{" "}
								<b>
									{getValues("finVente").format(
										"dddd D MMMM"
									)}
								</b>
								<br />
								La vente s’ouvrira le{" "}
								<b>
									{getValues("debutVente").format(
										"dddd D MMMM"
									)}
								</b>{" "}
								à 9h.
								<br />
								Elle se terminera le{" "}
								<b>
									{getValues("finVente").format(
										"dddd D MMMM"
									)}
								</b>{" "}
								à 10h.
								<br />
								Les produits pourront être récupérés le{" "}
								<b>
									{getValues("livraisonVente").format(
										"dddd D MMMM"
									)}
								</b>
							</Typography>
						</Grid>
					)}
			</Grid>
		</LocalizationProvider>
	);
}
